import React, { useState } from "react";
import { BiSolidDownArrow } from "react-icons/bi";
import {
  TreeWithThreeTilesDynamicZoneModel,
  TreeWithThreeTilesVariant,
} from "@models/strapi-components/tree-with-three-tiles";
import Title from "@components/common/Title";
import { twMerge } from "tailwind-merge";
import VizWrapper from "@components/common/Base/VizWrapper";
import DemoCustomerTiles from "@components/common/DemoCustomerTiles";
import TreeTile from "./TreeTile";
import { useWindowSize } from "@uidotdev/usehooks";

export interface TreeWithThreeTilesPropsModel {
  componentData: TreeWithThreeTilesDynamicZoneModel;
  hideBranches?: boolean;
}

const TreeWithThreeTiles: React.FunctionComponent<
  TreeWithThreeTilesPropsModel
> = ({ componentData, hideBranches = false }) => {
  const { title, tiles, divColor, variant } = componentData;
  const [height, setHeight] = useState(0);
  const dynamicClassName = hideBranches
    ? "xl:h-[388px]"
    : `xl:h-[${height + 544}px]`;

  const { width: windowWidth } = useWindowSize();

  const handlePostRenderHeightSetting = (height: number) => {
    setHeight(height);
  };

  const shouldHideBranches =
    hideBranches || variant === TreeWithThreeTilesVariant.WITHOUT_BRANCH;

  const renderTile = () => {
    return tiles.map((tile) => {
      return (
        <TreeTile
          tile={tile}
          handlePostRenderHeightSetting={handlePostRenderHeightSetting}
          key={tile?.id}
        />
      );
    });
  };

  const renderBranches = () => {
    if (hideBranches) return <></>;
    return (
      <>
        <div className="h-6 justify-center hidden xl:flex">
          <BiSolidDownArrow className="fill-white" size={24} />
        </div>
        <div className="link_level_1 relative hidden xl:block" />
        <div className="link_level_2 relative hidden xl:block" />
        <div className="link_straight relative hidden xl:block" />
      </>
    );
  };

  const heightOfWrapper =
    windowWidth && windowWidth > 1280
      ? height + 450
      : height * tiles.length + 400;

  if (shouldHideBranches) {
    return <DemoCustomerTiles tiles={tiles} divColor={divColor ?? "#FFFFFF"} />;
  }

  return (
    <VizWrapper
      className={twMerge("relative font-semibold text-white", dynamicClassName)}
      style={{
        backgroundColor: divColor ?? "#5D80FF",
        height: `${heightOfWrapper}px`,
      }}
    >
      <div>
        <div className="flex flex-col items-center px-8 leading-[48px]">
          <Title
            variant="h2"
            titleText={title}
            className="text-dark-purple-50 text-center pb-14 xl:pb-0 md:max-w-[42%] mx-auto"
          />
        </div>
        <div className="relative flex justify-center xl:block xl:p-0">
          {renderBranches()}
          <div className="xl:grid grid-cols-3 xl:absolute top-[150px] w-3/4 left-[12.5%] xl:h-auto">
            {renderTile()}
          </div>
        </div>
      </div>
    </VizWrapper>
  );
};
export default TreeWithThreeTiles;
